import React from 'react';
import cns from 'classnames';
import styles from './features.module.scss';
import { Link } from 'react-router-dom';
import RequestDemoButton from './RequestDemoButton';
import { Image } from 'react-bootstrap';

/**
 *
 *
 * @param {*} { data, variant = 'primary, none, secondary', title, subtitle }
 * @return {*}
 */
function Features({
  data,
  variant = 'secondary',
  title,
  subtitle,
  itemsPerRow = '5',
  itemClass = '',
}) {
  return (
    <div
      className={cns(styles.wrapper, {
        [styles.primary]: variant === 'primary',
        [styles.secondary]: variant === 'secondary',
      })}
    >
      <div className={styles.heading}>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
      <div className={`row row-cols-2 row-cols-lg-${itemsPerRow}`}>
        {data.map((item) => (
          <div key={item.id} className="col mb-3">
            <div
              className={cns(
                'px-3 py-4 rounded h-100',
                {
                  'bg-tint': variant === 'primary',
                  'bg-white': variant === 'secondary',
                },
                itemClass
              )}
            >
              <span className="font-weight-bold">{item.id}</span>
              <p className="mb-0 mt-2">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
      <RequestDemoButton />
    </div>
  );
}
export function FeaturesLinks({
  data,
  variant = 'secondary',
  title,
  subtitle,
  itemsPerRow = '5',
  itemClass = '',
  hideNumber = false,
}) {
  return (
    <div
      className={cns(styles.wrapper, {
        [styles.primary]: variant === 'primary',
        [styles.secondary]: variant === 'secondary',
      })}
    >
      <div className={styles.heading}>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
      <div className={`row row-cols-2 row-cols-lg-${itemsPerRow}`}>
        {data.map((item, idx) => (
          <Link to={item.href} className="featureLinksItem">
            <div key={idx} className="col mb-3 h-100">
              <div
                className={cns(
                  'px-3 py-3 rounded h-100',
                  {
                    'bg-tint': variant === 'primary',
                    'bg-white': variant === 'secondary',
                  },
                  itemClass
                )}
              >
                {!hideNumber && (
                  <span className="font-weight-bold">{idx + 1}</span>
                )}
                {item.image && (
                  <Image src={item.image} className={styles.featureImage} />
                )}
                <p className="mb-0 mt-2">{item.name}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Features;
